import React, { useState } from 'react'
import '../style/admin.css'
import Sidebar from './partial/Sidebar'
import Header from './partial/Header'
import { Link } from 'react-router-dom'
import { FaEdit } from 'react-icons/fa'
import { FaPlus, FaTrash } from 'react-icons/fa6'
import { useAllPackageTypeQuery, useDeletePackageTypeMutation,  } from '../../redux/API/PackageTypeApi'
import DeleteModal from './partial/DeleteModal'
import toast, { Toaster } from 'react-hot-toast'
import ChangePassword from './partial/ChangePassword'

const AdminCategory = () => {
const [newClass, setNewClass] = useState("")
const [newSidebarClass, setNewSidebarClass] = useState("") 
const [showPass, setShowPass] = useState(false) 
const [showModal, setShowModal] = useState(false)  
const [deleteId, setDeletId] = useState('')
const {data, refetch} = useAllPackageTypeQuery()
const [deleteData]  = useDeletePackageTypeMutation()


const handleShow = (id)  => {
  setDeletId(id)
  setShowModal(true)
}


const handleDelete = async () => {
  try {
    await deleteData(deleteId).unwrap();
    setShowModal(false);
    refetch();
    toast.success('Package Type Deleted Successfully');
  } catch (error) {
    setShowModal(false);

    if (error?.data?.errorType === "IN_USE") {
      toast.error("Cannot delete: Package Type is in use by existing packages.");
    } else {
      toast.error("Something went wrong, please try later.");
    }
  }
};


const handleToggle = () => {
  if (newClass === "") {
    setNewClass("main-active");
    } else {
      setNewClass("");
      }
      if(newSidebarClass === ""){
        setNewSidebarClass("closed");
      }
      else{
        setNewSidebarClass("");
      }
}


  return (
    <>
    <Toaster position='top-right'/>
    <Sidebar
    newSidebarClass={newSidebarClass}
    />
    <div className={`main-context ${newClass}`}>
      <Header
      handleToggle={handleToggle}
      setShowPass={setShowPass}
      />
      <div className="admin-dashboard p-4">
      <div aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item active" aria-current="page">Package Type</li>
  </ol>
  </div>
      <div className="d-flex justify-content-end pe-2 mb-3">
          {data?.data?.length >= 2 ? (
           <button className="btn btn-secondary" disabled>
             Max Package Types Reached
           </button>
         ) : (
           <Link to="/admin/add_package_type" className="btn btn-primary">
             Add Package Type <FaPlus />
           </Link>
         )}

          </div>
<div className=' card p-4'>
<div className="table-wrapper w-100  overflow-x-auto ">
<table className="table table-bordered ">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Package Name</th>
      <th scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
    {
      data && data?.data?.map((i, index) => (
        <tr key={i?._id}>
      <th scope="row">{index+1}</th>
      <td>{i?.name}</td>
      <td>
        <Link className='text-black' to={`/admin/package_type/${i._id}`}><FaEdit/></Link>
        <Link className='text-danger ms-4' onClick={() => handleShow(i._id)}><FaTrash/></Link>
      </td>
    </tr>
      ))
    }
  </tbody>
</table>
</div>
{/* <div className='d-flex justify-content-between  align-items-center '>
    <p className='m-0'>Showing 1 to 10 of 57 entries</p>
    <div aria-label="Page navigation example">
  <ul className="pagination">
    <li className="page-item"><Link className="page-link text-black " href="#">Previous</Link></li>
    <li className="page-item"><Link className="page-link text-black " href="#">1</Link></li>
    <li className="page-item"><Link className="page-link text-black " href="#">2</Link></li>
    <li className="page-item"><Link className="page-link text-black " href="#">3</Link></li>
    <li className="page-item"><Link className="page-link text-black " href="#">Next</Link></li>
  </ul>
</div>
</div> */}
</div>
</div>
</div>
{
  showModal && (
<DeleteModal
handleDelete={handleDelete}
setShowModal={setShowModal}
title={"Package Type"}
/>
  )
}
{
      showPass && (
        <ChangePassword
        setShowPass={setShowPass}
        />
      )
    }
    </>

  )
}

export default AdminCategory